import { render, staticRenderFns } from "./Prix.vue?vue&type=template&id=16f96ca6&"
import script from "./Prix.vue?vue&type=script&lang=js&"
export * from "./Prix.vue?vue&type=script&lang=js&"
import style0 from "./Prix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports